import { ProcedureType, SampleType } from "@/services/backend/types";
import { ReactElement } from "react";
import { useParams } from "react-router";
import CountingTable from "@/shared/components/domain/counting/counting-table";
import { useGetInspectionQuery } from "@/services/backend/inspections/service";

function CountingIndexRoute(): ReactElement {
  const { reportId } = useParams();
  const { data: inspection } = useGetInspectionQuery({ id: reportId! });
  const immutable = !!inspection?.inspection.immutable;

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col space-y-4">
        <CountingTable
          label="Oberflächenkeimprobe - 1N-RLT"
          ownerId={reportId as string}
          ownerType="inspections.Inspection"
          procedureType={ProcedureType.RLT1N}
          sampleType={SampleType.SurfaceMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Oberflächenkeimprobe - 2N-RLT"
          ownerId={reportId as string}
          ownerType="inspections.Inspection"
          procedureType={ProcedureType.RLT2N}
          sampleType={SampleType.SurfaceMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Luftkeimprobe - 1N-RLT"
          ownerId={reportId as string}
          ownerType="inspections.Inspection"
          procedureType={ProcedureType.RLT1N}
          sampleType={SampleType.AirMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Luftkeimprobe - 2N-RLT"
          ownerId={reportId as string}
          ownerType="inspections.Inspection"
          procedureType={ProcedureType.RLT2N}
          sampleType={SampleType.AirMicrobial}
          immutable={immutable}
        />
      </div>
    </div>
  );
}

export default CountingIndexRoute;
